import { render } from "./PolicyPrivacyPage.vue?vue&type=template&id=033af5a6&scoped=true"
import script from "./PolicyPrivacyPage.vue?vue&type=script&lang=js"
export * from "./PolicyPrivacyPage.vue?vue&type=script&lang=js"

import "../child/policyChildDoc.css?vue&type=style&index=0&lang=css"
import "./PolicyPrivacyPage.vue?vue&type=style&index=1&id=033af5a6&scoped=true&lang=css"

import exportComponent from "/apps/srv/jenkins/workspace/feihua_fe_mqimengweb_online/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-033af5a6"]])

export default __exports__